import { Lock } from "lucide-react";
import { BRAND } from "../../config/brand";
import { LoginForm } from "./LoginForm";

export const AdminLogin = ({ onLogin }) => (
  <div className="flex min-h-[100svh] items-center justify-center px-5">
    <LoginForm
      onLogin={onLogin}
      submitLabel="Sign in"
      className="w-full max-w-sm rounded-[32px] border border-white/10 bg-surface/80 p-7 backdrop-blur-xl"
      footer={<a href="/" data-testid="admin-back-to-app" className="mt-5 block text-center text-xs text-zinc-400 transition-colors hover:text-gold">← Back to SYNrise</a>}
    >
      <img src={BRAND.logoSmall} alt="SYNrise" className="h-16 w-16" />
      <h1 className="mt-5 font-display text-2xl font-bold text-zinc-50">Admin Area</h1>
      <p className="mt-1 flex items-center gap-2 text-sm text-zinc-400"><Lock className="h-3.5 w-3.5" /> Authorized SYNrise team only</p>
    </LoginForm>
  </div>
);
